import React from "react";

interface IPaymentTypeConditionalWrapperProps {
  paymentType: any;
  selectedPaymentType: string;
  children: React.ReactNode;
  standaloneChildren?: React.ReactNode;
}

/**
 * Simple wrapper that conditionally renders components based on payment type configuration
 * This eliminates the need for repeated boolean checks throughout the codebase
 */
function PaymentTypeConditionalWrapper(props: IPaymentTypeConditionalWrapperProps) {
  // If standalone integration is enabled, render standalone components
  if (props.paymentType.generic_standalone_integration) {
    return <>{props.standaloneChildren}</>;
  }
  
  // Otherwise render legacy components
  return <>{props.children}</>;
}

export default PaymentTypeConditionalWrapper; 